import { selectOfferCategory } from '.';
import { IAppState } from '../../../AppModulesWrapper';
import { getIsCommercial } from '../../utils/category/getIsCommercial';

export const selectIsCommercialCategory = (state: IAppState) => {
  const category = selectOfferCategory(state);

  return getIsCommercial(category);
};
